export const customScrollProps = {
  style: { display: 'flex' },
  autoHeight: true,
  autoHeightMax: 230,
  renderThumbVerticalStyle: { width: '4px' },
  renderTrackVerticalStyle: { width: '0px', padding: 0 },
  renderViewStyle: { flex: '1' },
};
